import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/esm/Button";
import BackArrow from "@/components/backArrow";
import { getAsset } from "@/helpers/helper";
import dummyUser from "@/assets/images/dummy/user-avatar-img.jpg";
import {
  LeftPanelSkeleton,
  MiniProfileSkeleton,
  TimelineSkeleton,
} from "@/components/common/SkeletonLoader/OtherProfileSkeleton";
import PostCard from "@/components/common/dashboard/posts/post-card";
import { useOtherUserProfile } from "@/hooks/auth/profile/use-other-user-profile";
import "./userProfile.css";
import Coverimg from "../UserProfile/Components/Coverimg/Cover";
import Profileimg from "../UserProfile/Components/Profileimg/profileimg";
import Profiletitle from "../UserProfile/Components/ProfileTitle/profiletitle";
import Profilesection from "../UserProfile/Components/Profile_section_1/Profilesection";

const resolveDescription = (desc) => {
  if (!desc) return "Not added yet";
  return typeof desc === "string" ? desc : desc?.text || "Not added yet";
};

const resolveContact = (contact) => {
  if (!contact) return "Not added yet";
  return typeof contact === "string"
    ? contact
    : contact?.text || contact?.primary || "Not added yet";
};

const Otheruserprofile = () => {
  const location = useLocation();

  const {
    id,
    name,
    infooo,
    checkconnect,
    connectionStatus,
    posts,
    createShop,
    setCreateShop,
    inputChange,
    userDatahandler,
    isVisitLoading,
    refetchVisit,
    leftSide,
    rightSide,
    widthHandler,
  } = useOtherUserProfile();

  const isCollapsed = leftSide === 2;
  const isUserProfile = location.pathname === "/user-profile";
  const avatarSrc = infooo?.imageUrl?.[0]
    ? getAsset(infooo.imageUrl[0])
    : dummyUser;

  const setInfooo = () => { };

  return (
    <Container className="other-profile-page">
      <Row className="gx-3">

        {!isCollapsed ? (
          <Col lg={leftSide} sm={12} className="ps-0 pe-0 screenHeight">
            <div className="b-radius border">
              <BackArrow back="/SellingSide" mystyle="ps-2 p-1" />

              {isVisitLoading ? (
                <LeftPanelSkeleton />
              ) : (
                <>
                  <Coverimg
                    widthHandler={widthHandler}
                    inputChange={inputChange}
                    userDatahandler={userDatahandler}
                    setCreateShop={setCreateShop}
                    infooo={infooo}
                    name={name}
                    setInfooo={setInfooo}
                  />
                  <Profileimg
                    infooo={infooo}
                    name={name}
                    setInfooo={setInfooo}
                  />
                  <Profiletitle
                    userDatahandler={userDatahandler}
                    inputChange={inputChange}
                    createShop={createShop}
                    infooo={infooo}
                    id={id}
                    checkconnect={checkconnect}
                    connectionStatus={connectionStatus}
                    refetchVisit={refetchVisit}
                  />

                  <div className="bg-vilot">
                    {checkconnect ? (
                      <Profilesection
                        userDatahandler={userDatahandler}
                        infooo={infooo}
                        setInfooo={setInfooo}
                        id={id}
                      />
                    ) : (
                      <div className="text-center p-4">
                        <p className="text-muted">
                          You must be connected to view Intro and Connections.
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </Col>
        ) : (
          <Col lg={2} sm={12} className="ps-0 pe-0 screenHeightd">
            <div className="miniProfile">
              {isVisitLoading ? (
                <MiniProfileSkeleton />
              ) : (
                <>
                  <div className="Profile-img-mini">
                    <img
                      className="ms-3"
                      src={avatarSrc}
                      alt={infooo?.fullname || "User"}
                      crossOrigin={infooo?.imageUrl?.[0] ? "anonymous" : undefined}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = dummyUser;
                      }}
                    />
                  </div>

                  <Col lg={12} md={12} className="d-flex justify-content-between mt-2">
                    <div>
                      <h4 className="ms-3">{infooo?.fullname || "Not added yet"}</h4>
                      <p className="ms-3" style={{ fontSize: "12px" }}>
                        {resolveDescription(infooo?.description)}
                      </p>
                    </div>
                  </Col>

                  <div className="bg-vilot">
                    <div className="bg-white pr-0 mt-2">
                      <h6>Profile Introduction</h6>
                      <ListGroup className="introBox list-unstyled font_small_profile">

                        <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                          {infooo?.address?.text || infooo?.address?.street || "Not added yet"}
                        </ListGroup.Item>

                        {infooo?.education?.length > 0 ? (
                          infooo.education.map((item, idx) => (
                            <ListGroup.Item key={idx} className="d-flex ms-3 border-0 p-1">
                              {item?.text || item || "Not added yet"}
                            </ListGroup.Item>
                          ))
                        ) : (
                          <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                            Not added yet
                          </ListGroup.Item>
                        )}

                        <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                          {resolveContact(infooo?.contactNumber)}
                        </ListGroup.Item>

                        <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                          {infooo?.email || "Not added yet"}
                        </ListGroup.Item>

                        <ListGroup.Item className="d-flex ms-3 border-0 p-1">
                          {infooo?.createdAt
                            ? String(infooo.createdAt).slice(0, 10)
                            : "Not added yet"}
                        </ListGroup.Item>

                      </ListGroup>

                      {isUserProfile && (
                        <Col lg={12}>
                          <NavLink to="/user-cv-form">
                            <div className="d-flex justify-content-center">
                              <Button
                                type="button"
                                className="btn ms-1 py-2 px-2 btn-primary-mini font_small_profile mb-4 mt-4"
                              >
                                Create CV
                              </Button>
                            </div>
                          </NavLink>
                        </Col>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </Col>
        )}

        <Col lg={rightSide} sm={12} className="ps-4 screenHeight" style={{ position: "relative" }}>
          <div className="border b-radius">
            <Col lg="12 p-2">
              <div className="noscroll timelinescroll-generalpublic">

                {isVisitLoading ? (
                  <TimelineSkeleton />
                ) : !checkconnect ? (
                  <div className="text-center p-4">
                    <h5 className="text-muted">First connect to see timeline</h5>
                  </div>
                ) : posts.length === 0 ? (
                  <div className="text-center p-4">
                    <h5 className="text-muted">No posts available</h5>
                  </div>
                ) : (
                  posts.map((post) => (
                    <PostCard
                      key={post._id}
                      post={post}
                      infooo={infooo}
                    />
                  ))
                )}

              </div>
            </Col>
          </div>
        </Col>

      </Row>
    </Container>
  );
};

export default Otheruserprofile;